import { CircularProgress, Stack } from '@mui/material'
import { useLayoutEffect, useMemo } from 'react'
import { useGetProfileQuery } from '../../../api'
import { NotFound } from '../../../components/ui-kit/NotFound'
import { UserSettingsForm } from './UserSettingsForm'
import { tUserToUserDescription } from './Mappers/tUserToUserDescription'

export const UserProfileSettings = () => {
  useLayoutEffect(() => {
    document.title = 'Настройки профиля пользователя'
  }, [])

  const { data: profileUser, isLoading, isError } = useGetProfileQuery()

  const initialData = useMemo(
    () => (profileUser ? tUserToUserDescription(profileUser) : null),
    [profileUser]
  )

  if (isLoading && !profileUser) {
    return (
      <Stack alignItems="center" justifyContent="center" minHeight={280}>
        <CircularProgress />
      </Stack>
    )
  }

  if (isError || !profileUser || !initialData) {
    return <NotFound text="Не удалось загрузить данные пользователя"/>
  }

  return <UserSettingsForm initialData={initialData} />
}

